import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

const baseEventParams = {
  page: '/deceso/datos-de-contacto',
  page_title: 'Deceso - Datos de Contacto',
  product: 'Seguro Deceso',
  view_type: 'web',
};

const pageViewDataLayer = (plan: DataLayerPlanType, insured: string, withAgent: boolean) => ({
  ...baseEventParams,
  action_type: 'Pageview',
  product_type: plan,
  asegurados: insured,
  venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()],
});

const goBackClickDataLayer = (plan: DataLayerPlanType, insured: string) => ({
  ...baseEventParams,
  action_type: 'click',
  product_type: plan,
  action: 'Click - Volver',
  asegurados: insured,
});

export const contactPageView = (planCode: string, insured: number, withAgent: boolean) =>
  BaseDataLayer({
    eventParams: pageViewDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), withAgent),
  });

export const contactGoBackClick = (planCode: string, insured: number) =>
  BaseDataLayer({
    eventParams: goBackClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
  });
